/**
 * Copyright (C) Siemens AG 1996-2026 ALL RIGHTS RESERVED.
 *
 * Brand domain constants shared by the Angular webapp and the NestJS services.
 *
 * Lives in the decorator-free `organization/util` library on purpose: the webapp imports these
 * values at runtime, and pulling them from the DTO barrel would evaluate the class-validator /
 * class-transformer decorated classes in the browser, where `Reflect.getMetadata` is not available.
 */

/** Logo MIME types accepted for upload (CF-06). SVGs are sanitised server-side before storage. */
export const BRAND_LOGO_ACCEPTED_TYPES = ['image/png', 'image/svg+xml'];

/** Maximum accepted logo file size in bytes (512 KB, CF-06). */
export const BRAND_LOGO_MAX_BYTES = 512 * 1024;

/** Minimum accepted logo height in pixels (CF-06). */
export const BRAND_LOGO_MIN_HEIGHT_PX = 64;

/** Base64 encodes every 3 input bytes as 4 output characters. */
const BASE64_INPUT_GROUP_BYTES = 3;
const BASE64_OUTPUT_GROUP_CHARS = 4;
const SVG_DATA_URL_PREFIX = 'data:image/svg+xml;base64,';

/**
 * Maximum accepted `logo.url` length: base64 inflates the binary by 4/3 (rounded up to a
 * whole 4-char group) plus the longest `data:image/svg+xml;base64,` prefix.
 */
export const BRAND_LOGO_MAX_DATA_URL_LENGTH =
  Math.ceil(BRAND_LOGO_MAX_BYTES / BASE64_INPUT_GROUP_BYTES) *
    BASE64_OUTPUT_GROUP_CHARS +
  SVG_DATA_URL_PREFIX.length;

/** Upper bound of brand domains per organisation until licence-tier limits are wired in. */
export const MAX_BRAND_DOMAINS_PER_ORGANIZATION = 50;

export const BRAND_LOGO_DATA_URL_REGEX =
  /^data:image\/(png|svg\+xml);base64,[A-Za-z0-9+/]+=*$/;
